export const useDocumentThesaurusStore = (documentId: string) => {
  return useDocumentThesaurus(documentId)();
};
